// Product types ids
export default {
  ELCANO_MASTER: 15,
  CADDIE_MASTER: 16,
  BE_ACTIVE_AWAY_MASTER: 26,
  SKI_MASTER: 2,
};



// WEBPACK FOOTER //
// ./src/utils/productTypesIds.js